import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Globalmarket(props) {
  return (
    <section className="tekrevol_dark_bg  tekgrip_img_uper  p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="example" data-text="Waste Conn App">
              <h2>Waste Connections</h2>
            </div>
            <p>
              We designed and integrated a dashboard to the app that
              encapsulated the complete analytics and process of waste that runs
              in the entire city.
            </p>
            <div className="btn_talk">
              <Link
                to="/case-studies/waste-connections"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                View Full Casestudy
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center"
          >
            <div className="tekgrip_tabs_image">
              <StaticImage
                src="../../../images/industries/logistics/Logistics-casestudy-app.webp"
                alt="logistics Software Development"
                className="img-fluid"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={600}
                height={561}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Globalmarket;
